module.exports = __webpack_public_path__ + "static/media/how_we_work2.76d5dc97.svg";